module.exports = __webpack_public_path__ + "static/img/android.fffa506c.png";